var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 109,
    viewBox: "0 0 104 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0723 36.139V104.75H52.1418H64.2113V36.139C67.4853 36.139 78.5281 35.972 91.8462 35.972C100.503 35.972 99.837 23.4518 90.6808 23.4518H52.7245H13.1033C3.61426 23.4518 4.11369 36.139 13.1033 36.139H40.0723Z",
    fill: "#2F3338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2377 11.9331C40.7997 21.4485 48.7291 23.2292 52.7245 23.4518C55.6655 23.4518 62.8795 21.4504 62.8795 13.1017C62.8795 4.42099 56.3869 1.75 52.225 1.75C47.5637 1.75 41.5911 4.25405 41.2377 11.9331Z",
    fill: "#2F3338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9242 66.5215H1.11713C0.506725 70.5836 1.98281 78.7078 12.7704 78.7078C23.558 78.7078 24.7011 70.5836 23.9242 66.5215Z",
    fill: "#2F3338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 66.6884H80.1929C80.0264 70.6949 82.0241 78.6745 91.3467 78.5409C100.669 78.4074 103 70.5836 103 66.6884Z",
    fill: "#2F3338"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0723 104.75H13.9357V107.25H86.5V104.75H64.2113H52.1418H40.0723Z",
    fill: "#2F3338"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0723 104.75H13.9357V107.25H86.5V104.75H64.2113M40.0723 104.75V36.139H13.1033M40.0723 104.75H52.1418M13.1033 36.139C4.11369 36.139 3.61426 23.4518 13.1033 23.4518M13.1033 36.139L1.11713 66.5215M13.1033 36.139L23.9242 66.5215M13.1033 23.4518C20.6318 23.4518 36.5117 23.4518 52.7245 23.4518M13.1033 23.4518H52.7245M90.6808 23.4518C99.837 23.4518 100.503 35.972 91.8462 35.972M90.6808 23.4518C81.3572 23.4518 66.9134 23.4518 52.7245 23.4518M90.6808 23.4518H52.7245M91.8462 35.972C78.5281 35.972 67.4853 36.139 64.2113 36.139V104.75M91.8462 35.972L80.1929 66.6884M91.8462 35.972L103 66.6884M64.2113 104.75H52.1418M52.3915 69.1925L52.1418 104.75M1.11713 66.5215H23.9242M1.11713 66.5215C0.506725 70.5836 1.98281 78.7078 12.7704 78.7078C23.558 78.7078 24.7011 70.5836 23.9242 66.5215M80.1929 66.6884H103M80.1929 66.6884C80.0264 70.6949 82.0241 78.6745 91.3467 78.5409C100.669 78.4074 103 70.5836 103 66.6884M52.7245 23.4518C48.7291 23.2292 40.7997 21.4485 41.2377 11.9331C41.5911 4.25405 47.5637 1.75 52.225 1.75C56.3869 1.75 62.8795 4.42099 62.8795 13.1017C62.8795 21.4504 55.6655 23.4518 52.7245 23.4518Z",
    stroke: "#2F3338",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.13e5fd79e7187d983fba2f822d017da3.svg";
export { ForwardRef as ReactComponent };